import { useNotificationRead } from '@/fsd/entities/notifications/model/hooks/useNotificationRead';
import { Button } from '@/fsd/shared/ui';
import { CheckCheckIcon } from '@/fsd/shared/ui/icons';
import styles from './CheckButton.module.scss';

export const CheckButton = () => {
  const { readNotification } = useNotificationRead({});

  return (
    <Button
      className={styles.checkButton}
      buttonType="icon"
      variant="link"
      size="l"
      onClick={() => {
        readNotification({
          action: 'mark_read',
          target: 'all',
        });
      }}
    >
      <CheckCheckIcon />
    </Button>
  );
};
